import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

  import GuidedQuiz from '@/views/GuidedQuiz.vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'

  import { CourseModule } from '@/store/modules/course'

  import type { CourseBundleOverview } from '@/services/interfaces/Course'

  import * as Sentry from '@sentry/vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmbeddedGuidedQuiz',
  setup(__props) {

  const { currentCourseId } = useCourse()
  const { showGuidedQuizRegisterModal, extractCourseVertical } = useCommonMixin()

  const embeddedQuizLoaded = ref(false)

  const loadingData = computed(
    () =>
      CourseModule.courseBundlesOverview === null ||
      CourseModule.course === null ||
      !(CourseModule.courseModules(currentCourseId.value).length > 0),
  )

  const currentPackage = computed(() => {
    const courseBundles = CourseModule.courseBundlesOverview as CourseBundleOverview[]
    return courseBundles?.find((bundle) => !!bundle.courses.find((c) => c.id === currentCourseId.value))
  })

  const courseVariant = computed(() => extractCourseVertical(currentPackage.value?.title ?? ''))

  const triggerRegisterModal = () => {
    if (currentPackage.value) {
      const allowedPrefixes = ['34i', '34d', '34f']
      const packageTitle = currentPackage.value.title

      const bundlePrefix = allowedPrefixes.find((prefix) => packageTitle.includes(prefix))

      if (bundlePrefix) {
        showGuidedQuizRegisterModal(bundlePrefix)
      }
    }
  }

  const fetchData = async () => {
    try {
      const promises = [
        await CourseModule.getCourse({ courseId: currentCourseId.value }),
        await CourseModule.getCourseModules(currentCourseId.value),
      ]

      await Promise.all(promises)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  const postIframeScrollHeight = () => {
    window.parent.postMessage({ action: 'resizeIframe', height: document.body.scrollHeight }, '*')
  }

  onMounted(() => {
    fetchData()
  })

  watch(loadingData, (value) => {
    if (!value) {
      postIframeScrollHeight()
    }
  })

  watch(embeddedQuizLoaded, (value) => {
    if (value) {
      setTimeout(() => {
        postIframeScrollHeight()
      }, 300)
    }
  })

return { __sfc: true,currentCourseId, showGuidedQuizRegisterModal, extractCourseVertical, embeddedQuizLoaded, loadingData, currentPackage, courseVariant, triggerRegisterModal, fetchData, postIframeScrollHeight, computed, onMounted, ref, watch, GuidedQuiz, LoadingSpinner, useCommonMixin, useCourse, CourseModule, Sentry }
}

})